module.exports = __webpack_public_path__ + "files/20ec2ce27d3a8f99c1da902bdb889ce8.svg";